import React, { Component } from 'react'
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import {setContentsApprove,setContentApprove} from '../../actions/contentsActions'
import {Col,Row} from 'reactstrap'
import isEmpty from '../../validation/is-empty';
import ContentApprove from '../common/ContentApprove'

class listContentsApprove extends Component {
  constructor(){
    super()
    this.onApprove = this.onApprove.bind(this)
    this.onReject = this.onReject.bind(this)
  }
  componentDidMount(){
    this.props.setContentsApprove()
  }
  onReject=(id)=>{
    console.log(id)
  }
  onApprove=(id)=>{
    this.props.setContentApprove(id)
  }
  render() {
    const {contentApprove} = this.props.contents
    return (
      <div className="main-content">
        <Row>
          <Col lg={11} className="mx-auto">
            <Row>
              {isEmpty(contentApprove) ? "" : contentApprove.map(content => 
                (<ContentApprove {...content} onApprove={this.onApprove} onReject={this.onReject}/>))
              }
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

listContentsApprove.propTypes = {
  setContentsApprove: PropTypes.func.isRequired,
  setContentApprove:PropTypes.func.isRequired,
  contents: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contents: state.contents
});

export default connect(mapStateToProps,{setContentsApprove,setContentApprove})(listContentsApprove)


// WEBPACK FOOTER //
// ./src/components/pages/listContentsApprove.js